<pp-advanced-filter-option-select
  class="advancedFilter__option"
  [ppItems]="advancedFilterLocationOptions"
  [ppOption]="option"
  (ppOptionChange)="changeFieldCondition($event)"
  ppClass="advancedFilter__option--condition"
></pp-advanced-filter-option-select>
